/* ==========================================================
   CLOUMANN — theme behaviour
   Mirrors the main site's header, reveal and gallery scripts,
   plus the Shopify-specific variant picker and quantity steppers.
   ========================================================== */
(function () {
  'use strict';

  /* ---- Sticky header shadow ------------------------------------------- */
  var header = document.getElementById('siteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Announcement bar height (keeps the fixed header below it) ------- */
  var bar = document.querySelector('.announcement');
  if (bar) {
    document.body.classList.add('has-announcement');
    var setBarHeight = function () {
      document.documentElement.style.setProperty('--announcement-h', bar.offsetHeight + 'px');
    };
    setBarHeight();
    window.addEventListener('resize', setBarHeight);
  }

  /* ---- Mobile menu ----------------------------------------------------- */
  var burger = document.getElementById('hamburger');
  var menu = document.getElementById('mobileMenu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        menu.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Scroll reveal --------------------------------------------------- */
  var revealables = document.querySelectorAll('.reveal');
  if (revealables.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      revealables.forEach(function (el) { io.observe(el); });
    } else {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---- Product gallery thumbnails -------------------------------------- */
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) {
    document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        galleryMain.src = full;
        var alt = thumb.getAttribute('data-alt');
        if (alt) galleryMain.alt = alt;
        document.querySelectorAll('.gallery-thumb').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  }

  /* ---- Quantity steppers ----------------------------------------------- */
  document.querySelectorAll('.qty-control').forEach(function (control) {
    var input = control.querySelector('input');
    if (!input) return;
    control.querySelectorAll('button[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Variant picker --------------------------------------------------
     Reads the variant JSON printed by sections/main-product.liquid, then
     keeps the hidden `id` input, price, availability and URL in sync.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.getAttribute('data-form'));
    var dataEl = document.getElementById(picker.getAttribute('data-variants'));
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var stockEl = document.querySelector('[data-stock]');
    function selectedOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) return checked.value;
          var select = group.querySelector('select');
          return select ? select.value : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      })[0];

      if (!match) {
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = match.compare_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (stockEl) {
        stockEl.classList.toggle('is-out', !match.available);
        var label = stockEl.querySelector('[data-stock-label]');
        if (label) label.textContent = match.available ? stockEl.getAttribute('data-in-stock') : stockEl.getAttribute('data-out-of-stock');
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.getAttribute('data-add-label') : submit.getAttribute('data-sold-label');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });
})();
